import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useLocation } from 'react-router-dom';
import BB from './images/BB.png';
import AddUserMale from './images/AddUserMale.png';
import Thumbsup from './images/Thumbsup.png';

function NotApproved() {
    const navigate = useNavigate();

    const HandleOK = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_FORE_APILINK}/user/user-logout`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-token': sessionStorage.getItem('token')
                }
            });

            const data = await response.json();

            if (response.ok) {
                // Clear local storage and session storage
                localStorage.removeItem('userData');
                sessionStorage.clear();

                // Redirect to login page
                navigate('/consumer');
            } else {
                // Handle logout error
                alert("logout failed");
                console.log('Logout failed');
            }
        } catch (error) {
            console.error('Error during logout:', error);
        }
    };

    return (
        <div className='flex flex-col items-center w-full'>
               <div className="relative w-full md:w-2/3 h-52 mb-6 overflow-hidden">
                 {/* <div className="absolute top-0 right-0 w-full h-full bg-gray-100"
                      style={{
                        clipPath: 'polygon(100% 0, 100% 100%, 0 100%)'
                      }}>
                 </div> */}


           <div className="relative w-full md:w-2/3 h-18 mb-2 py-2 mt-3 overflow-hidden border-b border-gray-200 bg-white">
             <div className="flex w-full h-full items-center justify-between z-10 px-1">
               <img src={BB} alt="Brickbucket Logo" className="h-16 w-16 object-contain ml-1" />
               <div className="flex items-center">
                 <img src={Thumbsup} alt="Add User" className="h-16 w-16 object-contain mr-3" />
                 <div>
                   <div className="text-[#170101] text-xl font-semibold leading-tight mr-3">Thank you </div>
                   <div className="text-[#170101] text-md font-bold leading-tight mr-3"> for registering</div>
                 </div>
               </div>
             </div>
           </div>
                 {/* Content container */}
                 {/* <div className="relative flex justify-between items-center w-full h-full px-4 z-10">
                   <div className="w-1/4 flex flex-col">
                     <img src={BB} alt="Brickbucket Logo" className="h-15 w-15 mb-20" />
                   </div>
                   <div className="w-1/3 flex flex-col items-end mt-10">
                     <img src={Thumbsup} alt="Add User" className="h-15" />
                     <h1 className="text-black text-xl font-bold whitespace-nowrap mt-2 mr-3">Thank You <span className ="text-lg font-semibold">for</span></h1>
                     <h2 className="text-black text-lg font-semibold whitespace-nowrap mr-8">registering</h2>
                   </div>
                 </div> */}
               </div>




           {/* New content with simplified structure */}
<div className="flex flex-col items-start justify-start w-full mx-auto px-4 mb-20">
    <h1 className="text-xl font-semibold text-[#000000] mb-6 ml-4">Thank You!</h1>
    <p className="text-[#000000] text-start text-lg mb-8 ml-4">
        Thank you for registering with Brickbucket. Our team will review your information and get back to you.
    </p>
</div>

<div className="flex flex-col items-center justify-center w-4/5 mx-auto mt-32">
    <button
    className="bg-[#D64541] text-white text-md rounded-md font-semibold px-5 py-3 mb-4 w-full transition duration-300 shadow-sm hover:bg-[#D93025]"
    onClick={HandleOK}>
    OK
</button>
</div>




        </div>
    );
}

export default NotApproved;
